/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
import * as React from 'react'
import { Link, Image } from './widgets'

const NextWrappers = { Link, Image }

export default NextWrappers
